module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet headerLogo\nif(utils.collectionSize(model.headerLogo) > 0){\nheaderLogo = helpers.detectRenderedImage(model.headerLogo, model._headerLogo)\n}\n%><section class=\"header\" style=\"width: 100%;\"><%\nif(headerLogo){\n%><img class=\"logo\" src=\"<%= headerLogo.rendered.url %>\" alt=\"<%= headerLogo.alt || headerLogo.title %>\" width=\"<%= headerLogo.rendered.width %>\" height=\"<%= headerLogo.rendered.height %>\"><%\n}\n%></section>"
  , __filename = "components/templates/core/documents/document/header.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let headerLogo
if(utils.collectionSize(model.headerLogo) > 0){
headerLogo = helpers.detectRenderedImage(model.headerLogo, model._headerLogo)
}

    ; __line = 6
    ; __append("<section class=\"header\" style=\"width: 100%;\">")
    ; 
if(headerLogo){

    ; __line = 8
    ; __append("<img class=\"logo\" src=\"")
    ; __append(escapeFn( headerLogo.rendered.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( headerLogo.alt || headerLogo.title ))
    ; __append("\" width=\"")
    ; __append(escapeFn( headerLogo.rendered.width ))
    ; __append("\" height=\"")
    ; __append(escapeFn( headerLogo.rendered.height ))
    ; __append("\">")
    ; 
}

    ; __line = 10
    ; __append("</section>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/document/header.ejs

}